"use client"

import { useState } from "react"
import { Button } from "@/components/ui/button"
import { Check, Star } from "lucide-react"
import Link from "next/link"
import { PricingCard } from "./PricingCard"

export function PricingSection() {
  const plans = [
    {
      name: "Free",
      price: "$0",
      description: "Get started with essential features. Perfect for individuals and new creators.",
      features: [
        "2 integrations",
        "Track Manual Earnings",
        "View follower + performance stats",
      ],
      cta: "Coming soon",
      popular: false,
      planKey: "free",
      comingSoon: true,
    },
    {
      name: "Pro",
      price: "$9.99",
      description: "For creators who want more integrations and insights. Unlock advanced analytics.",
      features: [
        "Up to 4 integrations",
        "Track Manual Earnings",
        "View follower + performance stats",
        "Performance Insights",
        "Custom: Daily, Weekly, Monthly Email Summaries",
      ],
      cta: "Coming soon",
      popular: true,
      planKey: "pro",
      comingSoon: true,
    },
    {
      name: "Creator+",
      price: "$29.99",
      description: "Unlimited integrations and advanced tools. Designed for growing creators.",
      features: [
        "Unlimited integrations",
        "Track Manual Earnings",
        "View follower + performance stats",
        "Performance Insights",
        "Custom: Daily, Weekly, Monthly Email Summaries",
        "Export Reports",
        "Custom Media Kit Builder",
        "Link generator (Affiliate Link Tools)",
      ],
      cta: "Coming Soon",
      popular: false,
      planKey: "creator+",
      comingSoon: true,
    },
    {
      name: "Team",
      price: "$99.99",
      description: "For teams needing collaboration and branded reports. All features, all users.",
      features: [
        "Unlimited integrations",
        "Track Manual Earnings",
        "View follower + performance stats",
        "Performance Insights",
        "Custom: Daily, Weekly, Monthly Email Summaries",
        "Export Reports",
        "Custom Media Kit Builder",
        "Link generator + link health tracking (Affiliate Link Tools)",
        "Team Roles & Permissions",
        "Customized & branded reports",
        "Tax documentation assistance",
      ],
      cta: "Coming Soon",
      popular: false,
      planKey: "team",
      comingSoon: true,
    },
  ]

  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center space-y-4 mb-16">
          <div className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-green-100 text-green-800 mb-4">
            🚀 Live Now - Start Your Free Trial
          </div>
          <h1 className="text-4xl lg:text-5xl font-bold text-gray-900">Pricing</h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Select a plan based on the number of channels and features you need. All plans include a 14-day free trial.
          </p>
        </div>

        {/* Pricing Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-8">
          {plans.map((plan, index) => (
            <PricingCard
              key={index}
              name={plan.name}
              price={plan.price}
              description={plan.description}
              features={plan.features}
              cta={plan.cta}
              popular={plan.popular}
              planKey={plan.planKey}
              comingSoon={plan.comingSoon}
              onCtaClick={() => {
                if (!plan.comingSoon) {
                  window.location.href = `/onboarding/start?plan=${plan.planKey}`;
                }
              }}
            />
          ))}
        </div>

        {/* Bottom note */}
        <div className="text-center mt-12 space-y-4">
          <p className="text-gray-600">
            All paid plans include a 14-day free trial.
          </p>
          <div className="bg-green-50 border border-green-200 rounded-lg p-4 max-w-md mx-auto">
            <p className="text-green-800 font-medium text-sm">
              🎉 Cancel anytime during your trial. No commitment required.
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}
